import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconCheck } from './icons';
import { FeatureItem, FeatureList } from './styled';

type PlanFeatureListProps = {
  maxCommunities: number;
  maxGroups: number;
  maxMembers: number;
  maxStorage: number;
  extras?: string[];
  muted?: boolean;
  style?: React.CSSProperties;
};

const PlanFeatureList = ({
  maxCommunities,
  maxGroups,
  maxMembers,
  maxStorage,
  extras = [],
  muted = false,
  style,
}: PlanFeatureListProps) => {
  const { t } = useTranslation();

  return (
    <FeatureList style={style}>
      <FeatureItem>
        <IconCheck muted={muted} />
        {t('subscriptions.profile.plan.featureCommunities', {
          count: maxCommunities,
        })}
      </FeatureItem>
      <FeatureItem>
        <IconCheck muted={muted} />
        {t('subscriptions.profile.plan.featureSchedulers', {
          count: maxGroups,
        })}
      </FeatureItem>
      <FeatureItem>
        <IconCheck muted={muted} />
        {t('subscriptions.profile.plan.featureMembers', {
          count: maxMembers,
        })}
      </FeatureItem>
      <FeatureItem>
        <IconCheck muted={muted} />
        {t('subscriptions.profile.plan.featureStorage', {
          count: maxStorage,
        })}
      </FeatureItem>
      {extras.map((line) => (
        <FeatureItem key={line}>
          <IconCheck muted={muted} />
          {line}
        </FeatureItem>
      ))}
    </FeatureList>
  );
};

export default PlanFeatureList;
